module.exports = __webpack_public_path__ + "fonts/unicons.31bc376.woff";